import { FC, useEffect, useState } from 'react';
import { Box, Grid, FormControl, Select, MenuItem, InputLabel, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIButton } from '../../../../atomic/atoms';
import { SCUIGeneralDrawerHeader } from '../../../../atomic/molecules';
import React from 'react';
import { PaymentQuery } from '../../../../services/query';
import { ISelectItem } from '../../Installment.helper';
import { IOM } from '../../installmentOptionManagement.classes';

export const SCUIInstallmentFilter: FC<IProps> = ({ countryList, filterInput, setFilterInput, search, onClose }) => {
    const { t } = useTranslation();

    const [creditCardTypes, setCreditCardTypes] = useState<ISelectItem[]>([]);
    const [installmentOptions, setInstallmentOptions] = useState<ISelectItem[]>([]);
    const [statuses, setStatuses] = React.useState<ISelectItem[]>([]);

    const getCreditCardTypeList = async (countryId: number) => {
        const creditTypeList = await PaymentQuery.GetCreditCardTypes({
            countryId: countryId,
        });

        let data: ISelectItem[] = [];
        if (creditTypeList && creditTypeList.data.length > 0) {
            data = creditTypeList.data.map((item: any) => ({
                id: item.creditCardTypeId,
                name: item.creditCardTypeName,
            }));
        }

        setCreditCardTypes(data);
    };

    const getInstallmentOptions = async () => {
        let options: ISelectItem[] = [
            { id: 1, name: '0' },
            { id: 2, name: '2' },
            { id: 3, name: '3' },
            { id: 4, name: '4' },
            { id: 5, name: '5' },
            { id: 6, name: '6' },
            { id: 7, name: '7' },
            { id: 8, name: '8' },
            { id: 9, name: '9' },
            { id: 10, name: '10' },
            { id: 11, name: '11' },
            { id: 12, name: '12' },
        ];
        setInstallmentOptions(options);
    };

    const getStatusList = () => {
        const data: ISelectItem[] = [
            { id: 1, name: t('general.active') },
            { id: 2, name: t('general.passive') },
        ];
        setStatuses(data);
    };

    useEffect(() => {
        getInstallmentOptions();
        getStatusList();
        if (filterInput.country != null && filterInput.country != undefined && filterInput.country?.id != undefined) {
            getCreditCardTypeList(filterInput.country.id);
        }
    }, []);

    return (
        <form
            className={IOM.filterForm}
            onSubmit={async (e: any) => {
                e.preventDefault();
            }}
        >
            <Grid container spacing={1} style={{ justifyContent: 'center' }}>
                <Box className={IOM.filterHeader}>
                    <SCUIGeneralDrawerHeader header={t('general.detailedFiltering')} onClose={onClose} />
                </Box>

                <Grid className={IOM.filterFieldCountry}>
                    <FormControl style={{ margin: '8px', width: 410 }}>
                        <InputLabel id="labelCountry">{t('general.country')}</InputLabel>
                        <Select
                            className={IOM.inputFilterCountry}
                            labelId="labelCountry"
                            id="parentMenuLabel"
                            value={filterInput.country?.id}
                            label={t('general.country')}
                            onChange={(event) => {
                                const { value } = event.target;
                                setFilterInput({
                                    ...filterInput,
                                    country: {
                                        id: value,
                                        name: countryList.find((x) => x.id == value)?.name,
                                    },
                                    creditCardType: null,
                                    numberOfInstallment: null,
                                });
                                getCreditCardTypeList(value);
                            }}
                        >
                            {countryList.length > 0 &&
                                countryList.map((item: any) => {
                                    return (
                                        <MenuItem
                                            value={item.id}
                                            key={item.id}
                                            className={IOM.filterCountryOption}
                                            data-country-id={item.id}
                                            data-country-name={item.name}
                                        >
                                            {item.name}
                                        </MenuItem>
                                    );
                                })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid className={IOM.filterFieldBank}>
                    <FormControl style={{ margin: '8px', width: 410 }}>
                        <InputLabel id="labelBank">{t('general.bank')}</InputLabel>
                        <Select
                            className={IOM.inputFilterBank}
                            labelId="labelBank"
                            id="parentMenuLabel"
                            label={t('general.bank')}
                            value={filterInput.creditCardType?.id}
                            onChange={(event: any) => {
                                const { value } = event.target;
                                if (value != '' && value != undefined) {
                                    setFilterInput({
                                        ...filterInput,
                                        creditCardType: {
                                            id: value,
                                            name: creditCardTypes.find((x) => value == x.id)?.name,
                                        },
                                        numberOfInstallment: null,
                                    });
                                }
                            }}
                        >
                            {creditCardTypes.length > 0 &&
                                creditCardTypes.map((item: any) => {
                                    return (
                                        <MenuItem
                                            value={item.id}
                                            key={item.id}
                                            className={IOM.filterBankOption}
                                            data-credit-card-type-id={item.id}
                                            data-credit-card-type-name={item.name}
                                        >
                                            {item.name}
                                        </MenuItem>
                                    );
                                })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid className={IOM.filterFieldNumberOfInstallments}>
                    <FormControl style={{ margin: '8px', width: 410 }}>
                        <TextField
                            className={IOM.inputFilterNumberOfInstallments}
                            select
                            id="selectNumberOfInstallments"
                            variant="outlined"
                            label={t('general.numberOfInstallments')}
                            slotProps={{
                                select: {
                                    label: '',
                                    multiple: true,
                                    value: filterInput.numberOfInstallment?.map((x: any) => parseInt(x.name)) ?? [],
                                    onChange: (event: any) => {
                                        const { value } = event.target;
                                        let options: any = [];
                                        if (value) {
                                            value.map((item: any) => {
                                                options.push({
                                                    id: item,
                                                    name: installmentOptions.find((x) => parseInt(x.name) == item)
                                                        ?.name,
                                                });
                                            });

                                            setFilterInput({
                                                ...filterInput,
                                                numberOfInstallment: options,
                                            });
                                        }
                                    },
                                },
                            }}
                        >
                            {installmentOptions.length > 0 &&
                                installmentOptions.map((item: any) => {
                                    return (
                                        <MenuItem
                                            key={item.id}
                                            value={parseInt(item.name)}
                                            className={IOM.filterInstallmentOption}
                                            data-installment-id={item.id}
                                            data-installment-name={item.name}
                                        >
                                            {item.name == '0'
                                                ? t('installmentOptionManagement.singlePayment')
                                                : item.name}
                                        </MenuItem>
                                    );
                                })}
                        </TextField>
                    </FormControl>
                </Grid>
                <Grid className={IOM.filterFieldStatus}>
                    <FormControl style={{ margin: '8px', width: 410 }}>
                        <InputLabel id="labelStatus">{t('general.status')}</InputLabel>
                        <Select
                            className={IOM.inputFilterStatus}
                            labelId="labelStatus"
                            id="parentMenuLabel"
                            value={filterInput.status?.id}
                            label={t('general.status')}
                            onChange={(event) => {
                                const { value } = event.target;
                                setFilterInput({
                                    ...filterInput,
                                    status:
                                        value != '' && value != undefined
                                            ? {
                                                  id: value,
                                                  name: statuses.find((x) => x.id == value)?.name,
                                              }
                                            : null,
                                });
                            }}
                        >
                            <MenuItem
                                value=""
                                className={`${IOM.filterStatusOption} ${IOM.filterStatusOptionEmpty}`}
                                data-status-id=""
                            >
                                {t('general.select')}
                            </MenuItem>
                            {statuses.length > 0 &&
                                statuses.map((item: any) => {
                                    return (
                                        <MenuItem
                                            value={item.id}
                                            key={item.id}
                                            className={IOM.filterStatusOption}
                                            data-status-id={item.id}
                                            data-status-name={item.name}
                                        >
                                            {item.name}
                                        </MenuItem>
                                    );
                                })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid
                    className={IOM.filterActionsBox}
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        width: 410,
                        marginBottom: '20px',
                    }}
                >
                    <SCUIButton
                        className={IOM.btnFilterSubmit}
                        text={t('general.filter')}
                        type="primary"
                        sizeType="default"
                        size={'s'}
                        fullwidth
                        onClick={search}
                    />
                </Grid>
            </Grid>
        </form>
    );
};

interface IProps {
    countryList: ISelectItem[];
    filterInput?: any;
    setFilterInput?: any;
    search?: any;
    onClose?: any;
}
